import { createEntityAdapter } from '@reduxjs/toolkit';
import { AnswerResponsePrivate } from '@tests/types';

export const answersAdapter = createEntityAdapter<AnswerResponsePrivate<string>>();
